import {
    SearchComponentCustomer,
    queryComponentCustomer,
    queryComponetArea,
    queryComponetAuthArea,
    queryComponentUser,
    QuerySubmitPlanList,
    queryUserListAll,
    queryRegionTreeList,
    queryCompetiorAll,
    queryForecastClauseList,
    QueryStatusComponents,
    QueryDeptComponent,
    QueryPostComponent,
    QueryRoomAllList,
    QueryRoleList,
    QueryConfigItem,
    QueryRegionByAreaId,
    QueryComponentsClassify,
    QueryComponentsTypeByClassify,
    QueryComponentsType,
    QuerySubUser,
    QueryComponentAreaList,
    QueryStatus,
    QueryNotStatus,
    QueryPassStatus,
    QueryUserSubList,
    QueryPrecentCode,
    UpdatePrecentCode,
    QueryEmployeeAll,
    QueryActionTree,
    QueryRiskList,
    QueryActionComponent,
    QueryPostAll,
    QueryKeypointByUser,
    QueryVisitByAction,
    QueryindicatorAll,
    QueryDifficultReason,
    QueryDifficultAreaTree,
    QueryAuthDeptComponent,
    QueryOpportunityAll
} from '@/request/compoent';
import api from '@/utils/api';
import { renderChildren, sortRenderList } from '@/utils/common';
import {
    QueryComponentAreaAuth,
    QueryDoctorAll,
    QueryIndicatorByUserIds,
    QueryKpiByUser,
    QueryVisitPlanByAction
} from '../../request/compoent';
export default {
    namespace: true,
    state: {
        customerList: localStorage.getItem('customer_all') ? JSON.parse(localStorage.getItem('customer_all')) : [],
        customerNoList: [],
        areaList: [],
        areaListAll: [],
        areaAuthList: [],
        authOnlyList: [],
        userCustomerList: [],
        submitPlanList: [],
        userListAll: [],
        regionTreeList: [],
        areaTreeList: [],
        competiorAll: [],
        forecastClause: [],
        statusList: [],
        deptList: [],
        postList: [],
        roomList: [],
        roleAll: [],
        doctorAll: [],
        configItem: [],
        authAreaList: [],
        authAllList: [],
        regionList: [],
        classifyList: [],
        typeList: [],
        typeListAll: [],
        precentCode: [],
        configId: '',
        employeeList: [],
        actionTree: [],
        riskList: [],
        actionList: [],
        postAll: [],
        kpiAll: [],
        subUser: [],
        configValue: {},
        subUserList: [],
        keypointList: [],
        indicatorAll: [],
        authDeptList: [],
        indicatorTarget: [],
        difficultReason: [],
        difficultAreaTree: [],
        opportunityAll: []
    },
    mutations: {
        SET_COMPONENT_CUSTOMER_LIST(state, customerList) {
            state.customerList = customerList;
        },
        SET_COMPONENT_CUSTOMER_NO_LIST(state, customerNoList) {
            state.customerNoList = customerNoList;
        },
        SET_COMPONENT_AREA_LIST(state, areaList) {
            state.areaList = areaList;
        },
        SET_COMPONENT_AREA_LIST_ALL(state, areaListAll) {
            state.areaListAll = areaListAll;
        },

        SET_COMPONENT_AREA_AUTH_LIST(state, areaAuthList) {
            state.areaAuthList = areaAuthList;
        },

        SET_COMPONENT_AREA_AUTH(state, authOnlyList) {
            state.authOnlyList = authOnlyList;
        },

        SET_USER_CUSTOMER_LIST(state, userCustomerList) {
            state.userCustomerList = userCustomerList;
        },

        SET_SUBMIT_PLAN_LIST(state, submitPlanList) {
            state.submitPlanList = submitPlanList;
        },

        SET_USER_LIST_ALL(state, userListAll) {
            state.userListAll = userListAll;
        },

        SET_REGION_TREE_LIST(state, regionTreeList) {
            state.regionTreeList = regionTreeList;
        },

        SET_AREA_TREE_LIST(state, areaTreeList) {
            state.areaTreeList = areaTreeList;
        },

        SET_COMPETIOR_ALL(state, competiorAll) {
            state.competiorAll = competiorAll;
        },

        SET_FORECAST_CLAUSE(state, forecastClause) {
            state.forecastClause = forecastClause;
        },

        SET_STATUS_LIST(state, statusList) {
            state.statusList = statusList;
        },

        SET_DEPT_COMPONENT(state, deptList) {
            state.deptList = deptList;
        },

        SET_AUTH_DEPT_COMPONENT(state, deptList) {
            state.authDeptList = deptList;
        },

        SET_POST_COMPONENT(state, postList) {
            state.postList = postList;
        },

        SET_ROOM_LIST(state, roomList) {
            state.roomList = roomList;
        },

        SET_ROLE_ALL_LIST(state, roleAll) {
            state.roleAll = roleAll;
        },

        SET_DOCTOR_ALL(state, doctorAll) {
            state.doctorAll = doctorAll;
        },

        SET_CONFIG_ITEM(state, configItem) {
            state.configItem = configItem;
        },

        SET_AREA_AUTH_LIST(state, authAreaList) {
            state.authAreaList = authAreaList;
        },
        SET_AREA_AUTH_ALL_LIST(state, authAllList) {
            state.authAllList = authAllList;
        },

        SET_REGION_LIST(state, regionList) {
            state.regionList = regionList;
        },

        SET_CLASSIFY_LIST(state, classifyList) {
            state.classifyList = classifyList;
        },

        SET_TYPE_LIST(state, typeList) {
            state.typeList = typeList;
        },

        SET_TYPE_LIST_ALL(state, typeListAll) {
            state.typeListAll = typeListAll;
        },
        SET_PRECENT_CODE(state, precentCode) {
            state.precentCode = precentCode;
        },
        SET_CONFIG_ID(state, configId) {
            state.configId = configId;
        },
        SET_EMPLOYEE_ALL(state, empoyeeList) {
            state.empoyeeList = empoyeeList;
        },
        SET_ACTION_TREE(state, actionTree) {
            state.actionTree = actionTree;
        },
        SET_RISK_LIST(state, riskList) {
            state.riskList = riskList;
        },
        SET_ACTION_LIST(state, actionList) {
            state.actionList = actionList;
        },
        SET_POST_ALL(state, postAll) {
            state.postAll = postAll;
        },

        SET_COMPONENT_KPI(state, kpiAll) {
            state.kpiAll = kpiAll;
        },

        SET_KEYPOINT_LIST(state, keypointList) {
            state.keypointList = keypointList;
        },
        SET_SUB_USER_LIST(state, subUserList) {
            state.subUserList = subUserList;
        },
        SET_SUB_USER(state, subUser) {
            state.subUser = subUser;
        },

        SET_INDICATOR_ALL(state, indicatorAll) {
            state.indicatorAll = indicatorAll;
        },

        SET_INDICATOR_TARGET_ALL(state, indicatorTarget) {
            state.indicatorTarget = indicatorTarget;
        },

        SET_DIFFICULT_REASON(state, difficultReason) {
            state.difficultReason = difficultReason;
        },
        SET_DIFFICULT_AREA_TREE(state, difficultAreaTree) {
            state.difficultAreaTree = difficultAreaTree;
        },
        SET_CONFIG_VALUE(state, configValue) {
            state.configValue = configValue;
        },
        SET_OPPORTUNITY_ALL(state, opportunityAll) {
            state.opportunityAll = opportunityAll;
        }
    },
    actions: {
        UPDATE_AUTH_LIST: async ({ commit }, payload) => {
            commit('SET_AREA_AUTH_LIST', []);
            commit('SET_AREA_AUTH_ALL_LIST', []);
        },
        RESET_KPI_ALL_LIST: async ({ commit }, payload) => {
            commit('SET_COMPONENT_KPI', []);
        },
        RESET_INDICATOR_TARGET_LIST: async ({ commit }, payload) => {
            commit('SET_INDICATOR_TARGET_ALL', []);
        },
        SearchCustomerList: async ({ commit }, payload) => {
            let res = await queryComponentCustomer(payload);
            if (res?.code == 200) {
                localStorage.setItem('customer_all', JSON.stringify(res.data ?? []));
                commit('SET_COMPONENT_CUSTOMER_LIST', res.data);
            }
            return res;
        },

        SearchCustomerNoAuth: async ({ commit }, payload) => {
            let res = await SearchComponentCustomer(payload);
            if (res?.code == 200) {
                commit('SET_COMPONENT_CUSTOMER_NO_LIST', res.data);
            }
            return res;
        },
        SearchAreaList: async ({ commit }, payload) => {
            let res = await queryComponetArea(payload);
            if (res?.code == 200) {
                let list = renderChildren(res.data ?? []);
                commit('SET_COMPONENT_AREA_LIST', list ?? []);
            }
            return res;
        },

        QUERY_COMPONENT_AREA_LIST: async ({ commit }, payload) => {
            let res = await QueryComponentAreaList(payload);
            if (res?.code == 200) {
                let list = renderChildren(res.data ?? []);
                commit('SET_COMPONENT_AREA_LIST_ALL', list ?? []);
            }
            return res;
        },
        SearchAreaAuthList: async ({ commit }, payload) => {
            let res = await queryComponetAuthArea(payload);
            if (res?.code == 200) {
                let list = renderChildren(res.data ?? []);
                commit('SET_COMPONENT_AREA_AUTH_LIST', list ?? []);
                commit('SET_COMPONENT_AREA_AUTH', res.data ?? []);
            }
            return res;
        },

        QUERY_AREA_AUTH: async ({ commit }, payload) => {
            let res = await QueryComponentAreaAuth(payload);
            if (res?.code == 200) {
                let list = renderChildren(res.data ?? []);
                commit('SET_AREA_AUTH_LIST', list ?? []);
                commit('SET_AREA_AUTH_ALL_LIST', res.data ?? []);
            }
            return res;
        },
        QUERY_USER_CUSTOMER_LIST: async ({ commit }, payload) => {
            let res = await queryComponentUser(payload);
            if (res?.code == 200) {
                commit('SET_USER_CUSTOMER_LIST', res.data ?? []);
            }
            return res;
        },

        QUERY_SUBMIT_PLAN_LIST: async ({ commit }, payload) => {
            let res = await QuerySubmitPlanList(payload);
            if (res?.code == 200) {
                let list = res.data.map(item => {
                    return {
                        ...item,
                        showName: item.customerName + '(' + item.visitDate + ')'
                    };
                });
                commit('SET_SUBMIT_PLAN_LIST', list);
            }
            return res;
        },

        QUERY_USER_LIST_ALL: async ({ commit }, payload) => {
            let res = await queryUserListAll(payload);
            if (res?.code == 200) {
                commit('SET_USER_LIST_ALL', res.data ?? []);
            }
            return res;
        },

        QUERY_REGION_TREE_LIST: async ({ commit }, payload) => {
            let res = await queryRegionTreeList(payload);
            if (res?.code == 200) {
                let list = renderChildren(res.data ?? []);
                commit('SET_REGION_TREE_LIST', list);
                commit('SET_AREA_TREE_LIST', res.data);
            }
            return res;
        },

        QUERY_COMPETIOR_ALL: async ({ commit }, payload) => {
            let res = await queryCompetiorAll(payload);
            if (res?.code == 200) {
                commit('SET_COMPETIOR_ALL', res.data ?? []);
            }
            return res;
        },

        QUERY_FORECAST_CLAUSE: async ({ commit }, payload) => {
            let res = await queryForecastClauseList(payload);
            if (res?.code == 200) {
                commit('SET_FORECAST_CLAUSE', res.data ?? []);
            }
            return res;
        },

        QUERY_STATUS_COMPONENTS: async ({ commit }, payload) => {
            let res = await QueryStatusComponents();
            if (res?.code == 200) {
                commit('SET_STATUS_LIST', res.data ?? []);
            }
            return res;
        },

        QUERY_DEPT_COMPONENT: async ({ commit }, payload) => {
            let res = await QueryDeptComponent(payload);
            if (res?.code == 200) {
                let list = sortRenderList(res.data, 'sort', 'children');
                commit('SET_DEPT_COMPONENT', list);
            }
            return res;
        },

        QUERY_AUTH_DEPT_COMPONENT: async ({ commit }, payload) => {
            let res = await QueryAuthDeptComponent(payload);
            if (res?.code == 200) {
                let list = sortRenderList(res.data, 'sort', 'children');
                commit('SET_AUTH_DEPT_COMPONENT', list);
            }
            return res;
        },

        QUERY_POST_COMPONENT: async ({ commit }, payload) => {
            let res = await QueryPostComponent(payload);
            if (res?.code == 200) {
                commit('SET_POST_COMPONENT', res.data);
            }
            return res;
        },

        QUERY_ROOM_ALL_LIST: async ({ commit }, payload) => {
            let res = await QueryRoomAllList(payload);
            if (res?.code == 200) {
                commit('SET_ROOM_LIST', res.data ?? []);
            }
            return res;
        },

        QUERY_ROLE_ALL_LIST: async ({ commit }, payload) => {
            let res = await QueryRoleList();
            if (res?.code == 200) {
                commit('SET_ROLE_ALL_LIST', res.data ?? []);
            }
            return res;
        },

        QUERY_DOCTOR_ALL: async ({ commit }, payload) => {
            let res = await QueryDoctorAll(payload);
            if (res?.code == 200) {
                commit('SET_DOCTOR_ALL', res.data ?? []);
            }

            return res;
        },

        QUERY_EMPLOYEE_LIST: async ({ commit }, payload) => {
            let res = await QueryEmployeeAll(payload);
            if (res?.code == 200) {
                commit('SET_EMPLOYEE_ALL', res.data ?? []);
            }
            return res;
        },

        QUERY_CONFIG_ITEM: async ({ commit }, payload) => {
            let res = await QueryConfigItem(payload);
            if (res?.code == 200) {
                commit('SET_CONFIG_ITEM', res.data);
            }
            return res;
        },

        QUERY_REGION_LIST_BY_AREAID: async ({ commit }, payload) => {
            let res = await QueryRegionByAreaId(payload);
            return res;
        },

        QUERY_COMPONENTS_CLASSIFY: async ({ commit }, payload) => {
            let res = await QueryComponentsClassify(payload);
            if (res?.code == 200) {
                commit('SET_CLASSIFY_LIST', res.data ?? []);
            }
            return res;
        },

        QUERY_COMPONENTS_TYPE_BY_CLASSIFY: async ({ commit }, payload) => {
            let res = await QueryComponentsTypeByClassify(payload);
            if (res?.code == 200) {
                commit('SET_TYPE_LIST', res.data ?? []);
            }
            return res;
        },

        QUERY_COPONENTS_TYPE: async ({ commit }, payload) => {
            let res = await QueryComponentsType(payload);
            if (res?.code == 200) {
                commit('SET_TYPE_LIST_ALL', res.data ?? []);
            }
            return res;
        },

        QUERY_SUB_USER: async ({ commit }, payload) => {
            let res = await QuerySubUser(payload);
            if (res?.code == 200) {
                commit('SET_SUB_USER_LIST', res.data ?? []);
            } else {
                commit('SET_SUB_USER_LIST', []);
            }
            return res;
        },

        QUERY_PASS_STATUS: async ({ commit }, payload) => {
            let res = await QueryPassStatus(payload);
            return res;
        },
        QUERY_NOT_STATUS: async ({ commit }, payload) => {
            let res = await QueryNotStatus(payload);
            return res;
        },
        QUERY_USER_SUB_LIST: async ({ commit }, payload) => {
            let res = await QueryUserSubList(payload);
            if (res?.code == 200) {
                commit('SET_SUB_USER', res.data);
            }
            return res;
        },

        QUERY_PRECENT_CODE: async ({ commit }, payload) => {
            let res = await QueryPrecentCode(payload);
            if (res?.code == 200) {
                let code = res.data.value?.split(',');
                commit('SET_PRECENT_CODE', code ?? []);
                commit('SET_CONFIG_ID', res.data.configId);
            }
            return res;
        },

        QUERY_CONFIG_VALUE: async ({ commit }, payload) => {
            let res = await QueryPrecentCode(payload);
            if (res?.code == 200) {
                commit('SET_CONFIG_VALUE', res.data ?? {});
            } else {
                commit('SET_CONFIG_VALUE', {});
            }
            return res;
        },

        QUERY_CONFIG_CODE: async ({}, payload) => {
            let res = await QueryPrecentCode(payload);
            return res;
        },

        UPDATE_PRECENT_CODE: async ({ commit }, payload) => {
            let res = await UpdatePrecentCode(payload);
            return res;
        },

        QUERY_ACTION_TREE: async ({ commit }, payload) => {
            let res = await QueryActionTree(payload);
            if (res?.code == 200) {
                commit('SET_ACTION_TREE', res.data ?? []);
            }
            return res;
        },

        QUERY_RISK_LIST: async ({ commit }, payload) => {
            let res = await QueryRiskList(payload);
            if (res?.code == 200) {
                commit('SET_RISK_LIST', res.data ?? []);
            }
            return res;
        },

        QUERY_ACTION_COMPONENT: async ({ commit }, payload) => {
            let res = await QueryActionComponent(payload);
            if (res?.code == 200) {
                commit('SET_ACTION_LIST', res.data ?? []);
            }
            return res;
        },

        QUERY_KPI_BY_USER: async ({ commit }, payload) => {
            let res = await QueryKpiByUser(payload);
            if (res?.code == 200) {
                commit('SET_COMPONENT_KPI', res.data ?? []);
            }
            return res;
        },

        QUERY_INDICATOR_BY_USER_IDS: async ({ commit }, payload) => {
            let res = await QueryIndicatorByUserIds(payload);
            if (res?.code == 200) {
                commit('SET_INDICATOR_TARGET_ALL', res.data ?? []);
            }
            return res;
        },

        QUERY_POST_ALL: async ({ commit }, payload) => {
            let res = await QueryPostAll(payload);
            if (res.code == 200) {
                commit('SET_POST_ALL', res.data ?? []);
            }
            return res;
        },

        QUERY_KEYPOINT_LIST: async ({ commit }, payload) => {
            let res = await QueryKeypointByUser(payload);
            if (res?.code == 200) {
                commit('SET_KEYPOINT_LIST', res.data ?? []);
            }
            return res;
        },

        QUERY_VISIT_BY_ACTION: async ({}, payload) => {
            let res = await QueryVisitByAction(payload);
            return res;
        },

        QUERY_VISIT_PLAN_BY_ACTION: async ({}, payload) => {
            let res = await QueryVisitPlanByAction(payload);
            return res;
        },

        QUERY_INDICATOR_ALL: async ({ commit }, payload) => {
            let res = await QueryindicatorAll(payload);
            if (res?.code == 200) {
                commit('SET_INDICATOR_ALL', res.data ?? []);
            }
            return res;
        },

        QUERY_DIFFICULT_REASON_LIST: async ({ commit }, payload) => {
            let res = await QueryDifficultReason(payload);
            if (res?.code == 200) {
                commit('SET_DIFFICULT_REASON', res.data ?? []);
            } else {
                commit('SET_DIFFICULT_REASON', []);
            }
            return res;
        },

        QUERY_DIFFICULT_AREA_TREE: async ({ commit }, payload) => {
            let res = await QueryDifficultAreaTree(payload);
            if (res?.code == 200) {
                commit('SET_DIFFICULT_AREA_TREE', res.data ?? []);
            } else {
                commit('SET_DIFFICULT_AREA_TREE', []);
            }
            return res;
        },

        QUERY_OPPORTUNITY_ALL: async ({ commit }, payload) => {
            let res = await QueryOpportunityAll(payload);
            if (res?.code == 200) {
                commit('SET_OPPORTUNITY_ALL', res.data ?? []);
            } else {
                commit('SET_OPPORTUNITY_ALL', []);
            }
            return res;
        }
    }
};
